import { ProductSummaryPage } from "../ProductSummaryPage"

export const NewSchoolTripSummaryPage = ({ values, refetch }: any) => {
  return <ProductSummaryPage product={values} refetch={refetch} />
}
